import { Component } from '@angular/core';
import { DialogBaseViewComponent, SimpleDialogData } from '@sb/library/base';

@Component({
    selector: 'lib-dialog-warning',
    templateUrl: './dialog-warning.component.html'
    //styleUrls: ['./dialog-warning.component.scss']
})
export class DialogWarningComponent extends DialogBaseViewComponent<SimpleDialogData> {
    override PrimaryAction() {
        super.PrimaryAction();
        this.DismissAction();
    }

    get primaryButtonText(): string {
        return this.data.PrimaryButtonText ?? $localize`:@@CommonClose:Close`;
    }
}
